import type { AssetsHttpClient } from "./createAssetsHttpClient";

export type PubNubKeys = {
  subscribeKey: string;
  cipherKey: string;
};

/**
 * Creates an HQ-service client from an already-configured `AssetsHttpClient`
 * instance pointed at the HQ backend origin.
 *
 * @example
 * ```ts
 * const hqHttp = createAssetsHttpClient({
 *   fetch: (url, init) => fetchWithToken(url, { ...init, headers: { region: getRegion(), ...init?.headers } }),
 *   baseUrl: getEnvValue("HQ"),
 * });
 * const client = getHqClient(hqHttp);
 * ```
 */
export const getHqClient = (http: AssetsHttpClient) => ({
  getPubNubKeys: (): Promise<PubNubKeys> =>
    http.get<PubNubKeys>(`${http.baseUrl}/v1/notifications/consumer/config`),
});

/**
 * The shape returned by {@link getHqClient}.
 * Exported so consumers can type variables without spelling out
 * `ReturnType<typeof getHqClient>`.
 */
export type HqClient = ReturnType<typeof getHqClient>;
